module.exports = __webpack_public_path__ + "img/Mail.f7fad7fd.svg";